import { j as e } from "./jsx-runtime-944c88e2.js";
import { Box as l, Text as i, Flex as r, Stack as Se, Button as d } from "@chakra-ui/react";
import { u as Ce, T as t } from "./eMyAsurionProvider-5bc36307.js";
import "@tanstack/react-query";
import "react";
import "./useAccount-a03adfa5.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/icons";
import "./features-979fdcf7.js";
import "./providers-29a9425c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import { C as ye, L as We, a as ue } from "./LockIcon-7635fee6.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
const ti = ({
  title: Q = "Your request is submitted.",
  heading: V = "Your request ID:",
  requestId: Z = "",
  text1: m = "",
  subheading1: p = "What happens next?",
  subheadingcontent1: g = "",
  DateTime: _ = "",
  subheadingcontent2: f = "",
  subheading2: b = "",
  subheading2content1: S = "",
  subheading2content2: C = "",
  subheading3: y = "",
  subheading3content1: W = "",
  info1: u = "",
  info1content: K = "",
  info2: A = "",
  info2content: $ = "",
  info3: z = "",
  info3content: k = "",
  searchTitle: Ke = "",
  lblhowtofind: F = "",
  lblrate: E = "",
  lblclose: w = "Close this page",
  rateButtonProps: a,
  closeButtonProps: h,
  howToFindButtonProps: j,
  IncidentType: s = "SWAP",
  doAnimate: Ae = !1,
  Date: $e,
  expertGroupImage: ze,
  serviceRequestdetails: D = "",
  paymentBreakdown: G = "",
  serviceRequestFee: N = "",
  serviceRequestFeeAmount: P = "",
  dataTransferFeesVal: I = "",
  dataTransferFeesLBL: R = "",
  nightDelivery: Y = "",
  nightDeliveryAmount: T = "",
  subTotal: U = "",
  subTotalAmount: B = "",
  Discount: ee = "",
  DiscountAmount: ie = "",
  TotalAfterDiscount: L = "",
  TotalAmountAfterDiscount: le = "",
  RequestedServicelbl: M = "",
  Summarylbl: ke = "",
  RequestedServicevalue: te = "",
  IMEIlbl: q = "",
  IMEIvalue: ne = "",
  RequestTypelbl: v = "",
  RequestTypevalue: re = "",
  DeliveryAddresslbl: H = "",
  Deliveryaddressvalue: se = "",
  DeliveryDateTimelbl: X = "",
  DeliveryDateTimevalue: xe = "",
  returnAddrsLBL: oe,
  returnAddrsVal: ae,
  returnDateTimeLBL: he,
  returnDateTimeVal: je,
  LFLStock: ce,
  isWarranty: J = !1,
  isWalkin: Fe = !1,
  make: c,
  showSurvey: de = !0,
  alternativeContactNumber: O = "",
  warrantyReturn: o = !1,
  ...me
}) => {
  const n = "ConfirmationAfterSubmission", { data: pe } = Ce(), { theme: ge } = pe, { colors: fe } = ge, { accent: be } = fe;
  return /* @__PURE__ */ e.jsxs(l, { children: [
    /* @__PURE__ */ e.jsxs(
      l,
      {
        p: "16px , 16px",
        ...me,
        w: { base: "full", lg: "60%" },
        margin: { base: "0", lg: "auto" },
        pb: { base: "0", lg: "100px" },
        children: [
          /* @__PURE__ */ e.jsx(i, { fontSize: "3xl", mb: "8px", children: /* @__PURE__ */ e.jsx(t, { text: Q, translationKey: `${n}/title` }) }),
          /* @__PURE__ */ e.jsxs(r, { children: [
            /* @__PURE__ */ e.jsx(i, { fontSize: "lg", mr: 1, children: /* @__PURE__ */ e.jsx(t, { text: V, translationKey: `${n}/heading` }) }),
            /* @__PURE__ */ e.jsx(i, { as: "b", fontSize: "lg", children: Z })
          ] }),
          ce && /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(l, { mb: "34px", pt: "8px", children: /* @__PURE__ */ e.jsxs(
            r,
            {
              direction: { base: "column", lg: "row" },
              justifyContent: { base: "start", lg: "space-between" },
              children: [
                /* @__PURE__ */ e.jsxs(
                  l,
                  {
                    w: { base: "full", lg: "50%" },
                    border: { base: "none", lg: "1px" },
                    padding: { base: "0", lg: "10px 16px" },
                    borderRadius: { base: "none", lg: "16px" },
                    borderColor: { base: "none", lg: "#adaaaa" },
                    children: [
                      /* @__PURE__ */ e.jsx(i, { fontSize: "2xl", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
                        t,
                        {
                          text: D,
                          translationKey: `${n}/serviceRequestdetails`
                        }
                      ) }),
                      M && /* @__PURE__ */ e.jsx(l, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                        t,
                        {
                          text: M,
                          translationKey: "Global/RequestedService"
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: te }) }),
                      q && /* @__PURE__ */ e.jsx(l, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                        t,
                        {
                          text: q,
                          translationKey: `${n}/lblIMEI`
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: ne }) }),
                      v && /* @__PURE__ */ e.jsx(l, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                        t,
                        {
                          text: v,
                          translationKey: "Global/RequestType"
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: re }) }),
                      O && /* @__PURE__ */ e.jsx(l, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                        t,
                        {
                          text: "Alternate Contact Number",
                          translationKey: "Global/AlternativeContactNumber"
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: O }) }),
                      H && /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { fontWeight: 700, mt: 2, children: H }) }),
                      /* @__PURE__ */ e.jsx(l, { children: se }),
                      X && /* @__PURE__ */ e.jsx(l, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(i, { children: X }) }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: xe }) }),
                      /* @__PURE__ */ e.jsx(l, { mt: 2, fontWeight: 700, children: oe }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: ae }) }),
                      /* @__PURE__ */ e.jsx(l, { mt: 2, fontWeight: 700, children: he }),
                      /* @__PURE__ */ e.jsx(l, { children: /* @__PURE__ */ e.jsx(i, { children: je }) })
                    ]
                  }
                ),
                " ",
                (o || !J) && // warrantyreturn will be false for all other cases
                /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  /* @__PURE__ */ e.jsx(l, { display: { base: "none", lg: "block" }, children: /* @__PURE__ */ e.jsx("hr", { style: { marginTop: "8px" } }) }),
                  /* @__PURE__ */ e.jsx(l, { mt: "16px", mb: "16px", children: /* @__PURE__ */ e.jsx(
                    "hr",
                    {
                      style: {
                        border: "none",
                        borderTop: "2px solid #adaaaa"
                      }
                    }
                  ) }),
                  /* @__PURE__ */ e.jsxs(l, { w: { base: "full", lg: "45%" }, children: [
                    G && /* @__PURE__ */ e.jsx(i, { my: 3, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: G,
                        translationKey: `${n}/lblPaymentBreakdown`
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(
                      r,
                      {
                        mb: 3,
                        direction: "row",
                        justifyContent: "space-between",
                        children: N && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                          /* @__PURE__ */ e.jsx(i, { children: N }),
                          /* @__PURE__ */ e.jsx(i, { children: P })
                        ] })
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      r,
                      {
                        mb: 3,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          R && /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(
                            t,
                            {
                              text: R,
                              translationKey: `${n}/lblDataTransferFees`
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(i, { children: I })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      r,
                      {
                        mb: 3,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          Y && /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(
                            t,
                            {
                              text: Y,
                              translationKey: `${n}/lblNightDelivery`
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(i, { children: T })
                        ]
                      }
                    ),
                    !J && /* @__PURE__ */ e.jsx(
                      "hr",
                      {
                        style: {
                          border: "none",
                          borderTop: "2px dotted #adaaaa"
                        }
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      r,
                      {
                        my: 2,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          U && /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(
                            t,
                            {
                              text: U,
                              translationKey: "Global/Subtotal"
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(i, { children: B })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      r,
                      {
                        mb: 2,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          /* @__PURE__ */ e.jsx(i, { children: ee }),
                          /* @__PURE__ */ e.jsx(i, { children: ie })
                        ]
                      }
                    ),
                    /* @__PURE__ */ e.jsxs(
                      r,
                      {
                        mb: 2,
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                          L && /* @__PURE__ */ e.jsx(i, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                            t,
                            {
                              text: L,
                              translationKey: "Global/Total"
                            }
                          ) }),
                          /* @__PURE__ */ e.jsx(i, { fontWeight: 700, children: le })
                        ]
                      }
                    )
                  ] }),
                  /* @__PURE__ */ e.jsx(l, { mt: "16px", mb: "16px", children: /* @__PURE__ */ e.jsx(
                    "hr",
                    {
                      style: {
                        border: "none",
                        borderTop: "2px solid #adaaaa"
                      }
                    }
                  ) })
                ] })
              ]
            }
          ) }) }),
          m && /* @__PURE__ */ e.jsx(i, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "36px", children: m }),
          /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            p && /* @__PURE__ */ e.jsx(
              i,
              {
                fontFamily: "Apercu Pro",
                fontWeight: "light",
                fontSize: "2xl",
                mb: "8px",
                children: /* @__PURE__ */ e.jsx(
                  t,
                  {
                    text: p,
                    translationKey: `${n}/lblSubheading1`
                  }
                )
              }
            ),
            g && /* @__PURE__ */ e.jsx(r, { children: /* @__PURE__ */ e.jsxs(
              i,
              {
                fontFamily: "Apercu Pro",
                fontWeight: "light",
                fontSize: "lg",
                mb: "36px",
                children: [
                  g,
                  " ",
                  /* @__PURE__ */ e.jsx("b", { children: _ })
                ]
              }
            ) })
          ] }),
          f && /* @__PURE__ */ e.jsx(i, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "24px", children: f }),
          b && /* @__PURE__ */ e.jsx(i, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "2xl", mb: "8px", children: /* @__PURE__ */ e.jsx(
            t,
            {
              text: b,
              translationKey: `${n}/lblSubheading2`
            }
          ) }),
          C && /* @__PURE__ */ e.jsx(i, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "8px", children: /* @__PURE__ */ e.jsx(
            t,
            {
              text: C,
              translationKey: `${n}/lblSubheading2Content2`
            }
          ) }),
          S && /* @__PURE__ */ e.jsx(i, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "lg", mb: "8px", children: /* @__PURE__ */ e.jsx(
            t,
            {
              text: S,
              translationKey: `${n}/lblSubheading2Content1`
            }
          ) }),
          !o && c && (s == null ? void 0 : s.toUpperCase()) !== "REPLACEMENT" && /* @__PURE__ */ e.jsx(Se, { mb: "24px", p: "0px , 16px", children: /* @__PURE__ */ e.jsx(
            d,
            {
              paddingY: "12px",
              colorScheme: "black",
              justifyContent: "flex-start",
              minWidth: "343px",
              fontWeight: "400",
              onClick: () => {
                var x;
                return (x = j == null ? void 0 : j.onClick) == null ? void 0 : x.call(j);
              },
              variant: "link",
              as: "u",
              children: F && /* @__PURE__ */ e.jsx(
                t,
                {
                  text: F,
                  translationKey: `${n}/lblHowToFind`
                }
              )
            }
          ) }),
          !o && y && /* @__PURE__ */ e.jsx(i, { fontFamily: "Apercu Pro", fontWeight: "light", fontSize: "2xl", mb: "8px", children: /* @__PURE__ */ e.jsx(
            t,
            {
              text: y,
              translationKey: `${n}/lblSubHeading3`
            }
          ) }),
          !o && W && /* @__PURE__ */ e.jsx(
            i,
            {
              fontFamily: "Apercu Pro",
              fontWeight: "light",
              fontSize: "lg",
              mb: "24px",
              whiteSpace: "pre-line",
              children: /* @__PURE__ */ e.jsx(
                t,
                {
                  text: W,
                  translationKey: `${n}/lblSubheading3Content1`
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsxs(l, { children: [
            !o && c && (s == null ? void 0 : s.toUpperCase()) !== "REPLACEMENT" && /* @__PURE__ */ e.jsxs(r, { mb: "24px", children: [
              /* @__PURE__ */ e.jsx(
                ye,
                {
                  marginTop: "6px",
                  borderRadius: "64px",
                  marginRight: "20px",
                  flexShrink: 0
                }
              ),
              /* @__PURE__ */ e.jsxs(r, { direction: "column", children: [
                u && /* @__PURE__ */ e.jsx(
                  i,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "bold",
                    fontSize: "sm",
                    m: 0,
                    children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: u,
                        translationKey: `${n}/lblInfo11`
                      }
                    )
                  }
                ),
                K && /* @__PURE__ */ e.jsx(
                  i,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "light",
                    fontSize: "sm",
                    children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: K,
                        translationKey: `${n}/lblInfo1Content`
                      }
                    )
                  }
                )
              ] })
            ] }),
            !o && c && (s == null ? void 0 : s.toUpperCase()) !== "REPLACEMENT" && /* @__PURE__ */ e.jsxs(r, { mb: "24px", children: [
              /* @__PURE__ */ e.jsx(
                We,
                {
                  marginTop: "6px",
                  borderRadius: "64px",
                  marginRight: "20px",
                  flexShrink: 0
                }
              ),
              /* @__PURE__ */ e.jsxs(r, { direction: "column", children: [
                A && /* @__PURE__ */ e.jsx(
                  i,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "bold",
                    fontSize: "sm",
                    m: 0,
                    children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: A,
                        translationKey: `${n}/lblInfo2`
                      }
                    )
                  }
                ),
                $ && /* @__PURE__ */ e.jsx(
                  i,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "light",
                    fontSize: "sm",
                    children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: $,
                        translationKey: `${n}/lblInfo2Content`
                      }
                    )
                  }
                )
              ] })
            ] }),
            (!o || (s == null ? void 0 : s.toUpperCase()) === "SWAP") && /* @__PURE__ */ e.jsxs(r, { mb: "24px", children: [
              /* @__PURE__ */ e.jsx(
                ue,
                {
                  marginTop: "4px",
                  borderRadius: "64px",
                  marginRight: "20px",
                  flexShrink: 0
                }
              ),
              /* @__PURE__ */ e.jsxs(r, { direction: "column", children: [
                z && /* @__PURE__ */ e.jsx(
                  i,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "bold",
                    fontSize: "sm",
                    m: 0,
                    children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: z,
                        translationKey: `${n}/lblInfo3`
                      }
                    )
                  }
                ),
                k && /* @__PURE__ */ e.jsx(
                  i,
                  {
                    fontFamily: "Apercu Pro",
                    fontWeight: "light",
                    fontSize: "sm",
                    children: /* @__PURE__ */ e.jsx(
                      t,
                      {
                        text: k,
                        translationKey: `${n}/lblInfo3content`
                      }
                    )
                  }
                )
              ] })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(
      l,
      {
        position: { base: "relative", lg: "fixed" },
        bottom: "0",
        w: "full",
        mt: "36px",
        pb: "10px",
        bgColor: { base: "", lg: "#faf9f5" },
        display: de ? "block" : "none",
        children: [
          /* @__PURE__ */ e.jsx(l, { display: { base: "none", lg: "block" }, children: /* @__PURE__ */ e.jsx(
            "hr",
            {
              style: {
                border: "none",
                borderTop: "2px solid #adaaaa"
              }
            }
          ) }),
          /* @__PURE__ */ e.jsxs(r, { direction: { base: "column", lg: "row-reverse" }, align: "center", py: "10px", children: [
            /* @__PURE__ */ e.jsx(
              d,
              {
                paddingX: "16px",
                paddingY: "12px",
                colorScheme: "primary",
                w: { base: "full", lg: "13%" },
                margin: "auto",
                onClick: () => {
                  var x;
                  return (x = a == null ? void 0 : a.onClick) == null ? void 0 : x.call(a);
                },
                children: E && /* @__PURE__ */ e.jsx(t, { text: E, translationKey: `${n}/lblRate` })
              }
            ),
            /* @__PURE__ */ e.jsx(
              d,
              {
                paddingX: "16px",
                paddingY: "12px",
                color: be,
                w: { base: "full", lg: "5%" },
                margin: "auto",
                onClick: () => {
                  var x;
                  return (x = h == null ? void 0 : h.onClick) == null ? void 0 : x.call(h);
                },
                cursor: "pointer",
                variant: "link",
                as: "u",
                children: w && /* @__PURE__ */ e.jsx(t, { text: w, translationKey: "Global/CloseThisPage" })
              }
            )
          ] })
        ]
      }
    )
  ] });
};
export {
  ti as ConfirmationAfterSubmission
};
